import { action, observable, computed } from 'mobx';

import { isBoolean, isString } from '~/common/utils/typeCheckers';


class NumberPickerClass {
    @observable selectedNumberCategory = '';
    @observable selectedTollFreeNumberCategory = 'vanity';
    @observable confirmedNumber = false;

    @action setSelectedNumberCategory(string) {
        this.selectedNumberCategory = isString(string, this.selectedNumberCategory);
    }

    @action setSelectedTollFreeNumberCategory(string) {
        this.selectedTollFreeNumberCategory = isString(string, this.selectedTollFreeNumberCategory);
    }

    @action setConfirmedNumber(bool) {
        this.confirmedNumber = isBoolean(bool, this.confirmedNumber);
    }

    @computed get isNumberTypeTransfer() {
        return this.selectedNumberCategory && this.selectedNumberCategory === 'transfer';
    }
}


const numberPickerStore = new NumberPickerClass();
export { numberPickerStore, NumberPickerClass };
